import cn from 'classnames';
import { CoordinateObject } from '@widgets/create-warehouse/map';
import {
  CreateWarehouseStep,
  ICreateWarehouseStepProps,
} from '@@/warehouses/components/create-warehouse-step';

import styles from './styles.module.sass';

export function InputOutput(props: IInputOutputProps) {
  const {
    className,
    topPosition,
    bottomPosition,
    onUpdateTopPosition,
    onUpdateBottomPosition,
    currentMode,
    ...rest
  } = props;
  const rootClass = cn(styles.root, className);

  return (
    <CreateWarehouseStep
      className={rootClass}
      next={{ disabled: currentMode == 'setInput' ? !topPosition : !bottomPosition }}
      {...rest}
    >
      <p className={styles.header}>
        {currentMode == 'setInput'
          ? 'Укажите точку заезда на поле'
          : 'Укажите точку выезда с поля'}
      </p>

      <div className={styles.points}>
        {currentMode == 'setInput' ? (
          <div
            className={cn(styles.point, {
              [styles.point_active]: currentMode == 'setInput',
            })}
          >
            <button
              className={styles.button}
              type="button"
              onClick={onUpdateTopPosition}
            >
              <i>
                {/* TODO: вынести */}
                <svg
                  className={styles.inputIcon}
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="9.28564"
                    cy="10"
                    r="8.57143"
                    transform="rotate(180 9.28564 10)"
                    fill="white"
                    stroke="currentColor"
                    strokeWidth="1.14286"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00007 14.8573C8.76338 14.8573 8.5715 14.6654 8.5715 14.4287V6.89195L5.44597 10.0175C5.2786 10.1848 5.00725 10.1848 4.83988 10.0175C4.67251 9.8501 4.67251 9.57875 4.83988 9.41138L8.69702 5.55424C8.86439 5.38687 9.13575 5.38687 9.30312 5.55424L13.1603 9.41138C13.3276 9.57875 13.3276 9.8501 13.1603 10.0175C12.9929 10.1848 12.7215 10.1848 12.5542 10.0175L9.42864 6.89195V14.4287C9.42864 14.6654 9.23676 14.8573 9.00007 14.8573Z"
                    fill="currentColor"
                  />
                </svg>
              </i>

              <span>
                {topPosition
                  ? `${Math.round(1000000 * topPosition.latitude) / 1000000}, ${
                      Math.round(1000000 * topPosition.longitude) / 1000000
                    }`
                  : 'указать въезд'}
              </span>
            </button>
          </div>
        ) : (
          <div
            className={cn(styles.point, {
              [styles.point_active]: currentMode == 'setOutput',
            })}
          >
            <button
              className={styles.button}
              type="button"
              onClick={onUpdateBottomPosition}
            >
              <i>
                {/* TODO: вынести */}
                <svg
                  className={styles.outputIcon}
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="9.71436"
                    cy="9.5"
                    r="8.57143"
                    fill="white"
                    stroke="currentColor"
                    strokeWidth="1.14286"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99993 4.64272C10.2366 4.64272 10.4285 4.83459 10.4285 5.07129L10.4285 12.6081L13.554 9.48253C13.7214 9.31516 13.9928 9.31516 14.1601 9.48253C14.3275 9.6499 14.3275 9.92125 14.1601 10.0886L10.303 13.9458C10.1356 14.1131 9.86425 14.1131 9.69688 13.9458L5.83974 10.0886C5.67237 9.92125 5.67237 9.64989 5.83974 9.48253C6.00711 9.31516 6.27847 9.31516 6.44583 9.48253L9.57136 12.6081L9.57136 5.07129C9.57136 4.83459 9.76324 4.64272 9.99993 4.64272Z"
                    fill="currentColor"
                  />
                </svg>
              </i>

              <span>
                {bottomPosition
                  ? `${Math.round(1000000 * bottomPosition.latitude) / 1000000}, ${
                      Math.round(1000000 * bottomPosition.longitude) / 1000000
                    }`
                  : 'указать выезд'}
              </span>
            </button>
          </div>
        )}
      </div>
    </CreateWarehouseStep>
  );
}

export interface IInputOutputProps extends ICreateWarehouseStepProps {
  topPosition?: CoordinateObject;
  bottomPosition?: CoordinateObject;
  onUpdateTopPosition: () => void;
  onUpdateBottomPosition: () => void;
  currentMode?: string;
}
